module.exports = __webpack_public_path__ + "h5/img/dsh001.d17306e8.gif";